import React from "react";
import NiaImg from "../../assets/Blackwomen/BlackWoman4.png";
import AmaImg from "../../assets/Blackwomen/BlackWoman2.png";
import ZuriImg from "../../assets/Blackwomen/BlackWoman3.png";

export default function TestimonialsSection() {
  return (
    <section className="bg-[#CFF098] py-14 mt-10 max-w-7xl mx-auto w-full px-5 md:px-10 rounded-3xl mb-20">
      <div className="mx-auto max-w-6xl px-5">
        <h3 className="text-3xl md:text-4xl text-gray-900 text-center mb-8">
          Results Other Braiders Are Seeing
        </h3>
        <div className="grid md:grid-cols-3 gap-6 ">
          <figure className="bg-[#F6F3F1] p-6 rounded-xl shadow-sm">
            <blockquote className="text-gray-800">
              “I was nervous about investing in a website at first, but within the first month I booked 20 new clients who found me online. The booking system makes it so easy for them to schedule, and I’ve had multiple repeat customers already. It honestly feels like my business leveled up overnight.”
            </blockquote>
            <figcaption className="mt-4 flex items-center gap-3 text-sm text-gray-600">
              <img src={NiaImg} alt="Nia" className="w-8 h-8 rounded-full object-cover" />
              <span>— Nia, Houston</span>
            </figcaption>
          </figure>

          <figure className="bg-[#F6F3F1] p-6 rounded-xl shadow-sm">
            <blockquote className="text-gray-800">
              “Before this, I was juggling Instagram DMs and text messages, which was so stressful. Now clients just go straight to my site, pick a time, and pay their deposit. I save hours every week, and I can actually focus on braiding instead of chasing messages. My chair stays full and I finally feel in control of my business.”
            </blockquote>
            <figcaption className="mt-4 flex items-center gap-3 text-sm text-gray-600">
              <img src={AmaImg} alt="Ama" className="w-8 h-8 rounded-full object-cover" />
              <span>— Ama, Austin</span>
            </figcaption>
          </figure>

          <figure className="bg-[#F6F3F1] p-6 rounded-xl shadow-sm">
            <blockquote className="text-gray-800">
              “With the VIP plan, I never have to worry about updating my site or keeping up with SEO — it’s all handled for me. My site looks professional, I’m ranking higher on Google, and I’ve noticed a steady flow of new clients booking every week. It’s like having my own tech and marketing team working in the background.”
            </blockquote>
            <figcaption className="mt-4 flex items-center gap-3 text-sm text-gray-600">
              <img src={ZuriImg} alt="Zuri" className="w-8 h-8 rounded-full object-cover" />
              <span>— Zuri, Dallas</span>
            </figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
}
